export default "__VITE_ASSET__0baa3c7f__"